import { EmailType, SystemCode, titleGroup3, titleGroup5, titleGroups } from "../../../../../constants";
import { StringHelper } from "../../../../../helper";
import { TitleCode, useEmployees, useSteps } from "../../../../../hook";
import { UserHelper } from "../utils";

interface VariablesInitStep {
  branchCode: string;
  titleCode: string;
  dayOffNumber: number;
  initialize: any;
  eTeamLead: string;
  eApproverBy: any;
  unitCode: string;
  isOverseas: boolean;
}

export const useAFLSteps = () => {
  const { employees, NBAEmployees, DADEmployee } = useEmployees();

  const res = useSteps({
    approved: EmailType.AFLA,
    rejected: EmailType.AFLR,
    completed: EmailType.AFLF,
    canceled: EmailType.AFLHBC,
  });

  const { notify: notifyAnother } = useSteps({
    approved: EmailType.AAFLA,
    rejected: EmailType.AAFLR,
    completed: EmailType.AAFLF,
    canceled: EmailType.AAFLHBC,
  });

  const getSteps = (vars: VariablesInitStep) => {
    const { approvedBy, eAssignee, empty } = res.getAvailableStep(SystemCode.AFL, vars.eApproverBy);
    const isTSN = ["TSN", "VTSN", "1"].includes(vars.branchCode);
    const isNBA = ["NBA", "VNBA", "2"].includes(vars.branchCode);
    const isDAD = ["DAD", "VDAD", "3"].includes(vars.branchCode);
    const isKCQ = vars.branchCode === "KCQ";
    const isTitleGroup1 = UserHelper.inGroup(vars.titleCode, titleGroups.one);
    const isTitleGroup2 = UserHelper.inGroup(vars.titleCode, titleGroups.two);
    const isTitleGroup3 = UserHelper.inGroup(vars.titleCode, titleGroups.three);
    const isTitleGroup4 = UserHelper.inGroup(vars.titleCode, titleGroups.four);
    const isTitleGroup5 = UserHelper.inGroup(vars.titleCode, titleGroups.five);
    const isTitleGroup6 = UserHelper.inGroup(vars.titleCode, titleGroups.six);
    const isTitleGroup7 = UserHelper.inGroup(vars.titleCode, titleGroups.seven);
    const isDirector = UserHelper.inGroup(vars.titleCode, [TitleCode.GD]);
    const isDeptLeaderGroup = UserHelper.inGroup(vars.titleCode, [...titleGroup3, ...titleGroup5]);

    const teamLeadName = StringHelper.verticalBarSplit(vars.eTeamLead)[1];
    const teamLeadEmail = StringHelper.verticalBarSplit(vars.eTeamLead)[0];

    const stepTGD = { name: employees.TSN_TGD!.Title, email: employees.TSN_TGD!.eMail, title: "Tổng giám đốc" };
    const stepGD = { name: employees.TSN_GD!.Title, email: employees.TSN_GD!.eMail, title: "Giám đốc" };
    const stepGDNBA = { name: NBAEmployees.NBA_GD!.Title, email: NBAEmployees.NBA_GD!.eMail, title: "Giám đốc" };
    const stepGDDAD = { name: DADEmployee.DAD_GD!.Title, email: DADEmployee.DAD_GD!.eMail, title: "Giám đốc" };
    const stepTeamLead = { name: teamLeadName, email: teamLeadEmail, title: "Đội/Nhóm trưởng" };

    const stepTPKHHC = {
      name: DADEmployee.DAD_TP_KHHC!.Title,
      email: DADEmployee.DAD_TP_KHHC!.eMail,
      title: "Trưởng phòng KHHC",
    };

    const steps = [[vars.initialize]];

    if (isKCQ) {
      if (isTitleGroup1) {
        steps.push([{ ...empty, ...stepTGD }], [{ ...eAssignee, title: "Chủ tịch hội đồng thành viên" }]);
      } else if (isTitleGroup2) {
        steps.push([{ ...empty, ...stepTGD }]);
      } else if (isTitleGroup3) {
        if (vars.dayOffNumber < 3) {
          steps.push([{ ...approvedBy, title: "Thủ trưởng CQ/ĐV" }]);
        } else {
          steps.push([{ ...approvedBy, title: "Thủ trưởng CQ/ĐV" }], [{ ...empty, ...stepTGD }]);
        }
      } else {
        steps.push([{ ...empty, ...stepTeamLead }], [{ ...approvedBy, title: "Thủ trưởng CQ/ĐV" }]);
      }
    }
    if (isTSN) {
      if (isTitleGroup7) {
        if (isTitleGroup6) {
          steps.push([{ ...empty, ...stepGD }]);
        } else {
          steps.push([{ ...empty, ...stepTeamLead }], [{ ...empty, ...stepGD }]);
        }
      } else if (isTitleGroup4) {
        const ttt = vars.unitCode === "TSN-PVSD" ? employees.TSN_PVSD_TTT : employees.TSN_PVHK_TTT;
        const stepTTT = { name: ttt!.Title, email: ttt!.eMail, title: "Trưởng trung tâm" };
        steps.push([{ ...empty, ...stepTTT }], [{ ...empty, ...stepGD }]);
      } else if (isTitleGroup5) {
        steps.push(
          [{ ...empty, ...stepTeamLead }],
          [{ ...approvedBy, title: "Thủ trưởng CQ/ĐV" }],
          [{ ...empty, ...stepGD }],
        );
      } else {
        steps.push([{ ...empty, ...stepTeamLead }], [{ ...approvedBy, title: "Thủ trưởng CQ/ĐV" }]);
      }
    }
    if (isNBA) {
      if (isDirector) {
        steps.push([{ ...empty, ...stepTGD }]);
      } else if ((isTitleGroup1 && vars.dayOffNumber < 3) || (isTitleGroup2 && vars.dayOffNumber < 5)) {
        steps.push([{ ...empty, ...stepGDNBA }]);
      } else if ((isTitleGroup1 && vars.dayOffNumber >= 3) || (isTitleGroup2 && vars.dayOffNumber >= 5)) {
        steps.push([{ ...empty, ...stepGDNBA }], [{ ...empty, ...stepTGD }]);
      } else if (isDeptLeaderGroup && vars.dayOffNumber < 3) {
        steps.push([{ ...empty, ...approvedBy, title: "Trưởng phòng/trung tâm" }]);
      } else if (isDeptLeaderGroup && vars.dayOffNumber >= 3) {
        steps.push([{ ...empty, ...approvedBy, title: "Trưởng phòng/trung tâm" }], [{ ...empty, ...stepGDNBA }]);
      } else {
        steps.push([{ ...empty, ...stepTeamLead }], [{ ...empty, ...approvedBy, title: "Trưởng phòng/trung tâm" }]);
      }
    }
    if (isDAD) {
      if (isDirector) {
        steps.push([{ ...empty, ...stepTGD }]);
      } else if ((isTitleGroup1 && vars.dayOffNumber < 3) || (isTitleGroup2 && vars.dayOffNumber < 5)) {
        steps.push([{ ...empty, ...stepGDDAD }]);
      } else if ((isTitleGroup1 && vars.dayOffNumber >= 3) || (isTitleGroup2 && vars.dayOffNumber >= 5)) {
        steps.push([{ ...empty, ...stepGDDAD }], [{ ...empty, ...stepTGD }]);
      } else if (isTitleGroup5 || isTitleGroup6) {
        steps.push(
          [{ ...empty, ...approvedBy, title: "Trưởng bộ phận" }],
          [{ ...empty, ...stepTPKHHC }],
          [{ ...empty, ...stepGDDAD }],
        );
      } else if (vars.isOverseas) {
        steps.push(
          [{ ...empty, ...approvedBy, title: "Trưởng phòng/Trung tâm" }],
          [{ ...empty, ...stepTPKHHC }],
          [{ ...empty, ...stepGDDAD }],
        );
      } else {
        steps.push([{ ...empty, ...approvedBy, title: "Trưởng phòng/Trung tâm/Đội trưởng" }]);
      }
    }
    return steps;
  };

  const getMaternitySteps = (vars: VariablesInitStep) => {
    const { approvedBy, empty } = res.getAvailableStep(SystemCode.AFL, vars.eApproverBy);
    const isDAD = ["DAD", "VDAD", "3"].includes(vars.branchCode);

    const steps = [[vars.initialize]];
    const stepGDDAD = { name: DADEmployee.DAD_GD!.Title, email: DADEmployee.DAD_GD!.eMail, title: "Giám đốc" };
    const stepTPKHHC = {
      name: DADEmployee.DAD_TP_KHHC!.Title,
      email: DADEmployee.DAD_TP_KHHC!.eMail,
      title: "Trưởng phòng KHHC",
    };

    if (isDAD) {
      steps.push(
        [{ ...empty, ...approvedBy, title: "Trưởng bộ phận" }],
        [{ ...empty, ...stepTPKHHC }],
        [{ ...empty, ...stepGDDAD }],
      );
    }

    return steps;
  };

  const getNoSalarySteps = (vars: VariablesInitStep) => {
    const { approvedBy, empty } = res.getAvailableStep(SystemCode.AFL, vars.eApproverBy);
    const isDAD = ["DAD", "VDAD", "3"].includes(vars.branchCode);
    const isTSN = ["TSN", "VTSN"].includes(vars.branchCode);

    const steps = [[vars.initialize]];
    const stepTGD = { name: employees.TSN_TGD!.Title, email: employees.TSN_TGD!.eMail, title: "Tổng giám đốc" };

    const stepTPKHHCDAD = {
      name: DADEmployee?.DAD_TP_KHHC!.Title,
      email: DADEmployee?.DAD_TP_KHHC!.eMail,
      title: "Trưởng phòng KHHC",
    };

    const stepTPTCNLTSN = {
      name: employees?.TSN_TCNL!?.Title,
      email: employees?.TSN_TCNL!?.eMail,
      title: "Phòng TCNL",
    };

    const stepGD = { name: employees.TSN_GD!.Title, email: employees.TSN_GD!.eMail, title: "Tổng giám đốc" };

    if (isDAD && vars.dayOffNumber > 60) {
      steps.push(
        [{ ...empty, ...approvedBy, title: "Thủ trưởng chi nhánh" }],
        [{ ...empty, ...stepTPKHHCDAD }],
        [{ ...empty, ...stepTGD }],
      );
    } else if (isTSN) {
      steps.push(
        [{ ...empty, ...approvedBy, title: "Thủ trưởng cơ quan đơn vị" }],
        [{ ...empty, ...stepTPTCNLTSN }],
        [{ ...empty, ...stepGD }],
      );
    }

    return steps;
  };

  const getSuspendContractSteps = (vars: VariablesInitStep) => {
    const { approvedBy, empty } = res.getAvailableStep(SystemCode.AFL, vars.eApproverBy);
    const isDAD = ["DAD", "VDAD", "3"].includes(vars.branchCode);
    const isTSN = ["TSN", "VTSN"].includes(vars.branchCode);

    const steps = [[vars.initialize]];
    const stepGDDAD = { name: DADEmployee.DAD_GD!.Title, email: DADEmployee.DAD_GD!.eMail, title: "Giám đốc" };
    const stepGD = { name: employees.TSN_GD!.Title, email: employees.TSN_GD!.eMail, title: "Tổng giám đốc" };

    const stepTPKHHC = {
      name: DADEmployee.DAD_TP_KHHC!.Title,
      email: DADEmployee.DAD_TP_KHHC!.eMail,
      title: "Trưởng phòng KHHC",
    };

    const stepTPTCNLTSN = {
      name: employees?.TSN_TCNL!?.Title,
      email: employees?.TSN_TCNL!?.eMail,
      title: "Phòng TCNL",
    };
    if (isDAD) {
      steps.push(
        [{ ...empty, ...approvedBy, title: "Bộ phận" }],
        [{ ...empty, ...stepTPKHHC }],
        [{ ...empty, ...stepGDDAD }],
      );
    } else if (isTSN) {
      steps.push(
        [{ ...empty, ...approvedBy, title: "Thủ trưởng cơ quan đơn vị" }],
        [{ ...empty, ...stepTPTCNLTSN }],
        [{ ...empty, ...stepGD }],
      );
    }

    return steps;
  };

  return { ...res, notifyAnother, getSteps, getMaternitySteps, getNoSalarySteps, getSuspendContractSteps };
};
